import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useSessionTimeoutAdmin } from '../hooks/useSessionTimeoutAdmin';

const TWO_FA_SETUP_PATH = '/admin/twoFactorAuth';

const PrivateRoute = ({ children }) => {
  const role = Number(localStorage.getItem('role'));
  const token = localStorage.getItem('jwt');
  const navigate = useNavigate();
  const location = useLocation();
  const [totpEnabled, setTotpEnabled] = useState(null);

  useSessionTimeoutAdmin(() => {
    localStorage.clear();
    navigate('/login');
  });

  useEffect(() => {
    if (!token || role !== 1) {
      setTotpEnabled(null);
      return;
    }

    let cancelled = false;

    const checkTotp = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_HOST}/admin/2fa/status`,
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        );
        const result = await response.json();
        if (cancelled) return;

        const enabled = Boolean(result.enabled);
        setTotpEnabled(enabled);
        localStorage.setItem('totpEnabled', enabled ? '1' : '0');
      } catch (_) {
        if (!cancelled) {
          setTotpEnabled(false);
          localStorage.setItem('totpEnabled', '0');
        }
      }
    };

    checkTotp();
    return () => {
      cancelled = true;
    };
  }, [token, role, location.pathname]);

  if (!token || role !== 1) {
    return <Navigate to="/login" />;
  }

  if (totpEnabled === null) {
    return (
      <div className="flex items-center justify-center min-h-[40vh] text-sm text-gray-600">
        Checking security settings...
      </div>
    );
  }

  if (!totpEnabled && location.pathname !== TWO_FA_SETUP_PATH) {
    return <Navigate to={TWO_FA_SETUP_PATH} replace />;
  }

  return children;
};

export default PrivateRoute;
